import { render, staticRenderFns } from "./PositionMenuForm.vue?vue&type=template&id=09f26a9f"
import script from "./PositionMenuForm.vue?vue&type=script&lang=js"
export * from "./PositionMenuForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports